var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNextDayIconActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5834 5.21656C30.4434 8.07649 32.0501 11.9554 32.0501 15.9999C32.0501 20.0445 30.4434 23.9234 27.5834 26.7833C24.7235 29.6432 20.8446 31.2499 16.8001 31.2499C12.7555 31.2499 8.8766 29.6432 6.01667 26.7833C3.15674 23.9234 1.55005 20.0445 1.55005 15.9999C1.55005 11.9554 3.15674 8.07649 6.01667 5.21656C8.8766 2.35663 12.7555 0.749935 16.8 0.749934C20.8446 0.749934 24.7235 2.35663 27.5834 5.21656Z",
    stroke: "#1377D4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.467 22.003L25.467 16.003L19.467 10.003",
    stroke: "#1377D4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.46671 16.0036L25.4667 16.0036",
    stroke: "#1377D4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextDayIconActive);
export default __webpack_public_path__ + "static/media/next-day-icon-active.0a1857538ee2c88c90fb9677ce4052b7.svg";
export { ForwardRef as ReactComponent };